export interface FeatureFlagInterface {
  name: FeatureFlag;
  label: string;
  enabled: boolean;
}

export enum FeatureFlag {
  NOTIFY_CHAT_MESSAGE_CASSIE = 'NOTIFY_CHAT_MESSAGE_CASSIE',
  EMAIL_PAGE = 'EMAIL_PAGE'
}

export const HTTP_STATUS_CODES = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  METHOD_NOT_ALLOWED: 405,
  CONFLICT: 409,
  INTERNAL_SERVER_ERROR: 500
} as const;

const isEmailEnablingTime = new Date() >= new Date('2026-05-26T20:00:00Z'); // 22:00 AMS time

export const featureFlagList: FeatureFlagInterface[] = [
  { label: 'Notify Chat Message for Cassie', enabled: false, name: FeatureFlag.NOTIFY_CHAT_MESSAGE_CASSIE },
  { label: 'Email', enabled: isEmailEnablingTime, name: FeatureFlag.EMAIL_PAGE }
];

// This function syncs the user's feature flags with the up-to-date hardcoded list (previously enabled flags are kept enabled)
const syncFeatureFlags = (userFeatureFlags: FeatureFlagInterface[]): FeatureFlagInterface[] => {
  // Get the names of the feature flags that the user has enabled
  const userEnabledFeatureFlags = userFeatureFlags.filter(flag => flag.enabled).map(flag => flag.name);

  // Return the updated list of feature flags with the user's enabled flags
  return featureFlagList.map(flag => ({
    ...flag,
    enabled: userEnabledFeatureFlags.includes(flag.name) || flag.enabled
  }));
};

export const HEADER_HEIGHT = 64;
export const TELEPHONY_BAR_HEIGHT = 51;
export const TOTAL_HEIGHT_WITH_TELEPHONY = HEADER_HEIGHT + TELEPHONY_BAR_HEIGHT;

export const REPORT_IMPROVEMENT_FORM_URL =
  'https://docs.google.com/forms/d/e/1FAIpQLSdrOAwmxAf-_XIeeoySwkWJ2v6EyAPoiLyPomoQmNRm122FQg/viewform';

export const REPORT_MALICIOUS_EMAIL_FORM_URL = 'https://coolblue-ellis.atlassian.net/servicedesk/customer/portal/1296';

export default syncFeatureFlags;
